module.exports = __webpack_public_path__ + "img/lollipop.9e370b4f.png";